export const dataSlider = [
   
  {
    id: 1,
    imgUrl: "banner_consultas.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://www.itetlax.org.mx/micrositio-consultas",
    linkToo: "https://www.itetlax.org.mx/micrositio-consultas",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  
  {
    id: 2,
    imgUrl: "banner_monografia.png",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/monografia.pdf",
    linkToo: "https://itetlax.org.mx/assets/pdf/monografia.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 3,
    imgUrl: "banner_muestral.png",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/documentos/estudio_muestral.pdf",
    linkToo: "https://itetlax.org.mx/assets/pdf/documentos/estudio_muestral.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 4,
    /* Bajar el 23 de Junio */
    imgUrl: "BANNER_PARLAMENTO_JUVENIL.jpg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/documentos/Parlamento_Juvenil.pdf",
    linkToo: "https://itetlax.org.mx/assets/pdf/documentos/Parlamento_Juvenil.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  
  /* 01/06/26 - 30/06/26 */
  {
    id: 7,
    imgUrl: "banner_2.jpeg",
    alt: "Banner",
    itemActive: "active",
    buttonActive: "",
    url: "",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 8,
    imgUrl: "banner_voces-01.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://participacion-ciudadana.itetlax.org.mx/nuestras_voces",
    linkToo: "",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 9,
    imgUrl: "banner_atcc_2.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://participacion-ciudadana.itetlax.org.mx/assets/pdf/_Estudio_Participacion.pdf",
    linkToo: "https://participacion-ciudadana.itetlax.org.mx/assets/pdf/_Estudio_Participacion.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 10,
    imgUrl: "banner_atcc_1.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://participacion-ciudadana.itetlax.org.mx/assets/pdf/_Informe_Resultados.pdf",
    linkToo: "https://participacion-ciudadana.itetlax.org.mx/assets/pdf/_Informe_Resultados.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 11,
    imgUrl: "banner_foto.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/convocatoria/Convocatoria_Foto.pdf",
    linkToo: "https://itetlax.org.mx/assets/pdf/convocatoria/Convocatoria_Foto.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  {
    id: 12,
    imgUrl: "banner_video.jpeg",
    alt: "Banner",
    itemActive: "",
    buttonActive: "",
    url: "https://itetlax.org.mx/assets/pdf/convocatoria/Convocatoria_Video.pdf",
    linkToo: "https://itetlax.org.mx/assets/pdf/convocatoria/Convocatoria_Video.pdf",
    modalimage: false,
    modalTitle: "",
    modalzip: false,
    zipFile: "",
    modaltext: false,
    title: "",
    textContent: [{ text: "", url: "" }],
  },
  
];
